import React from 'react';
import Storages from 'storages';
import DeviceData from 'drivers/deviceData';
import {
  LanguageHeader,
  LanguageGrid,
  LanguageItem,
  LanguageItemContent,
  LanguageIcon,
  LanguageName,
  StatusIndicator,
} from 'components/styles/Language.styled';
import { ModalOverlay, ModalContent } from 'components/styles/Common.styled';

import StorageKeys from 'enum/storages.enum';

import { translate as t } from 'utils/i18n';
import getIsRTLLanguage from 'utils/common/isRTL';

class LanguageModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModal: true,
      items: [],
    };
    this.onKeyPress = this.onKeyPress.bind(this);
  }

  async componentDidMount() {
    const language = this.props.value;

    const selectedLanguageId = Storages.MainStorage.getItem(StorageKeys.Keys.LANGUAGEID);

    let selected = -1;
    for (let index = 0; index < language.length; index++) {
      if (language[index].id == selectedLanguageId) {
        selected = index;
        break;
      }
    }

    if (selected == -1) {
      selected = 0;
    }

    const item = language[selected];

    this.setState(
      {
        items: language,
        focusIndex: selected,
      },
      () => {
        this.toggleItem(item);
      }
    );

    window.addEventListener('keydown', this.onKeyPress);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyPress);
  }

  modalclose() {
    this.setState({ ismodal: false });
  }

  handleClick = (e) => {
    this.props.cancel();
    this.props.getItem(null);
    this.setState({ isModal: !this.state.isModal });
  };

  handleConfirmation = (event, index, item) => {
    event.preventDefault();
    this.props.getItem(item);
  };

  handleEnter(currentItem) {
    this.props.getItem(currentItem);
  }

  toggleItem(currentItem) {
    const languages = this.state.items.map((item) => {
      return Object.assign(item, { active: currentItem.id === item.id });
    });

    this.setState({ items: languages });
  }

  async onKeyPress(event) {
    const tvKeyControls = await DeviceData.getTVControl();
    const isRTL = getIsRTLLanguage();

    let newIndex;
    const keyMapping = {
      [tvKeyControls.KEY_LEFT]: isRTL ? tvKeyControls.KEY_RIGHT : tvKeyControls.KEY_LEFT,
      [tvKeyControls.KEY_RIGHT]: isRTL ? tvKeyControls.KEY_LEFT : tvKeyControls.KEY_RIGHT,
      [tvKeyControls.KEY_UP]: isRTL ? tvKeyControls.KEY_DOWN : tvKeyControls.KEY_UP,
      [tvKeyControls.KEY_DOWN]: isRTL ? tvKeyControls.KEY_UP : tvKeyControls.KEY_DOWN,
    };

    switch (event.keyCode) {
      case keyMapping[tvKeyControls.KEY_RIGHT]:
        newIndex = this.state.focusIndex + 1;
        break;
      case keyMapping[tvKeyControls.KEY_DOWN]:
        newIndex = this.state.focusIndex + 1;
        break;
      case keyMapping[tvKeyControls.KEY_LEFT]:
        newIndex = this.state.focusIndex - 1;
        break;
      case keyMapping[tvKeyControls.KEY_UP]:
        newIndex = this.state.focusIndex - 1;
        break;
      case tvKeyControls.KEY_ENTER:
        newIndex = this.state.focusIndex;
        this.handleEnter(this.state.items[this.state.focusIndex]);
        break;
      case tvKeyControls.KEY_BACK:
        this.setState({ isModal: !this.state.isModal });
        this.props.cancel();
        event.preventDefault();
        break;
      default:
        break;
    }

    if (this.state.items.length === newIndex) newIndex = 0;
    if (newIndex < 0) newIndex = this.state.items.length - 1;

    if (newIndex >= 0 && newIndex < this.state.items.length) {
      this.setState(
        {
          focusIndex: newIndex,
        },
        function () {
          this.toggleItem(this.state.items[this.state.focusIndex]);
        }
      );
    }
  }

  getLanguageIcon(languageName) {
    const languageIcons = {
      English: 'EN',
      Arabic: '🇸🇦',
      French: '🇫🇷',
      Spanish: '🇪🇸',
      German: '🇩🇪',
      Italian: '🇮🇹',
      Portuguese: '🇵🇹',
      Russian: '🇷🇺',
      Chinese: '🇨🇳',
      Japanese: '🇯🇵',
      Korean: '🇰🇷',
      Hindi: '🇮🇳',
      Turkish: '🇹🇷',
      Dutch: '🇳🇱',
      Swedish: '🇸🇪',
      Norwegian: '🇳🇴',
      Danish: '🇩🇰',
      Finnish: '🇫🇮',
      Polish: '🇵🇱',
      Czech: '🇨🇿',
      Hungarian: '🇭🇺',
      Romanian: '🇷🇴',
      Bulgarian: '🇧🇬',
      Greek: '🇬🇷',
      Hebrew: '🇮🇱',
      Thai: '🇹🇭',
      Vietnamese: '🇻🇳',
      Indonesian: '🇮🇩',
      Malay: '🇲🇾',
      Filipino: '🇵🇭',
      Urdu: '🇵🇰',
      Bengali: '🇧🇩',
      Tamil: '🇮🇳',
      Telugu: '🇮🇳',
      Marathi: '🇮🇳',
      Gujarati: '🇮🇳',
      Kannada: '🇮🇳',
      Malayalam: '🇮🇳',
      Punjabi: '🇮🇳',
      Assamese: '🇮🇳',
      Odia: '🇮🇳',
      Kashmiri: '🇮🇳',
      Sindhi: '🇵🇰',
      Sinhala: '🇱🇰',
      Nepali: '🇳🇵',
      Mongolian: '🇲🇳',
      Kazakh: '🇰🇿',
      Kyrgyz: '🇰🇬',
      Uzbek: '🇺🇿',
      Tajik: '🇹🇯',
      Turkmen: '🇹🇲',
      Azerbaijani: '🇦🇿',
      Georgian: '🇬🇪',
      Armenian: '🇦🇲',
      Albanian: '🇦🇱',
      Macedonian: '🇲🇰',
      Serbian: '🇷🇸',
      Croatian: '🇭🇷',
      Slovenian: '🇸🇮',
      Slovak: '🇸🇰',
      Lithuanian: '🇱🇹',
      Latvian: '🇱🇻',
      Estonian: '🇪🇪',
      Icelandic: '🇮🇸',
      Irish: '🇮🇪',
      Welsh: '🇬🇧',
      Scottish: '🇬🇧',
      Catalan: '🇪🇸',
      Basque: '🇪🇸',
      Galician: '🇪🇸',
      Breton: '🇫🇷',
      Corsican: '🇫🇷',
      Occitan: '🇫🇷',
      Provençal: '🇫🇷',
      Walloon: '🇧🇪',
      Luxembourgish: '🇱🇺',
      Romansh: '🇨🇭',
      Frisian: '🇳🇱',
      Afrikaans: '🇿🇦',
      Swahili: '🇹🇿',
      Amharic: '🇪🇹',
      Somali: '🇸🇴',
      Hausa: '🇳🇬',
      Yoruba: '🇳🇬',
      Igbo: '🇳🇬',
      Zulu: '🇿🇦',
      Xhosa: '🇿🇦',
      Afrikaans: '🇿🇦',
      Kinyarwanda: '🇷🇼',
      Luganda: '🇺🇬',
      Kiswahili: '🇰🇪',
      Kinyarwanda: '🇷🇼',
      Kirundi: '🇧🇮',
      Chichewa: '🇲🇼',
      Sesotho: '🇱🇸',
      Setswana: '🇧🇼',
      Siswati: '🇸🇿',
      Xitsonga: '🇿🇦',
      Tshivenda: '🇿🇦',
      Sepedi: '🇿🇦',
      Sesotho: '🇱🇸',
      Setswana: '🇧🇼',
      Siswati: '🇸🇿',
      Xitsonga: '🇿🇦',
      Tshivenda: '🇿🇦',
      Sepedi: '🇿🇦',
    };

    return languageIcons[languageName] || '🌐';
  }

  render() {
    return (
      <ModalOverlay>
        <ModalContent>
          <LanguageHeader>
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
              {/* <BackCursor /> */}
              <h2>{t('Language.tittle')}</h2>
            </div>
          </LanguageHeader>

          <LanguageGrid>
            {this.state.items.length > 0 &&
              this.state.items.map((item, i) => (
                <LanguageItem
                  key={i}
                  active={item.active}
                  onClick={(e) => {
                    this.handleConfirmation(e, i, item);
                  }}
                >
                  <StatusIndicator active={item.active} />
                  <LanguageItemContent>
                    <LanguageIcon active={item.active}>
                      {this.getLanguageIcon(item.language_code)}
                    </LanguageIcon>
                    <LanguageName active={item.active}>{item.language_name}</LanguageName>
                  </LanguageItemContent>
                </LanguageItem>
              ))}
          </LanguageGrid>
        </ModalContent>
      </ModalOverlay>
    );
  }
}

export default LanguageModal;
